<form [formGroup]="currentForm">
    <ng-container *ngIf="(proposalService.calculatedPremiums$ | async) as
        calculatedPermiums;">
        <div nxRow class="save-offer wrapper-panel-component
            margin-box" formGroupName="saveOfferOwnerData">
            <div nxCol="12" class="heading">
                <h2 class="align-center">{{data['heading'] | translate}}</h2>
                <div *ngIf="data.subHeading">
                    <div class="enter-phone translated-paragraph">{{data.subHeading | translate}}</div>
                </div>
            </div>

            <div nxCol="12" class="data">
                <nx-formfield [label]="data.firstName | translate" *ngIf="data.firstName">
                    <input nxInput formControlName="firstName"  (change)="this.trackService.checkErrors(currentForm.controls.saveOfferOwnerData.get('firstName'), 'User first name')" 
                    />
                </nx-formfield>
                
                <nx-formfield [label]="data.lastName | translate" *ngIf="data.lastName">
                    <input nxInput formControlName="lastName">
                </nx-formfield>

                <nx-formfield [label]="data.email | translate" *ngIf="data.email">
                    <input nxInput formControlName="email"  (change)="trackService.pushEventTracking('user.emailAdress', currentForm.controls.saveOfferOwnerData.get('email').value)"      
                    (change)="this.trackService.checkErrors(currentForm.controls.saveOfferOwnerData.get('email'), 'User email address')"                pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,5}" />
                </nx-formfield>
           
                <nx-formfield *ngIf="data.phoneNumber">
                    <app-phone-numbers [mobilePhone]="mobilePhone" [mobileCode]="countryCode" trackingPath="user.mobilePhone" >
                    </app-phone-numbers>
                    <span nxFormfieldHint>+35988 488 76xx</span>
        
                </nx-formfield>

                <!-- <nx-formfield *ngIf="data.phoneNumber">
                    <nx-dropdown [showFilter]="true" class="phone-code" formControlName="countryCode">
                        <nx-dropdown-item *ngFor="let item of phoneCodes" [value]="'+' + item" (click)="this.trackService.pushEventTracking('user.mobilePhone', this.currentForm.controls.saveOfferOwnerData.get('countryCode').value+this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').value)">
                            {{ "+" + item }}
                        </nx-dropdown-item>
                    </nx-dropdown>
                    <input class="input-padding" [nxMask]="phoneMask"
                        [deactivateMask]="deactivateMask" 
                        [separators]="phoneSeparator"
                        maxlength='15'
                        [dropSpecialCharacters]="true"
                        [pattern]="phonePattern" 
                        type="text" nxInput formControlName="phoneNumber"
                        placeholder="{{ 'callMeBack.phoneNumber' | translate}}"
                        (blur)="this.trackService.checkErrors(currentForm.controls.saveOfferOwnerData.get('phoneNumber'), 'User mobile number')"
                        (blur)="this.trackService.pushEventTracking('user.mobilePhone', this.currentForm.controls.saveOfferOwnerData.get('countryCode').value+this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').value)"
                    />

                    <span nxFormfieldHint>+35988 488 76xx</span>
                </nx-formfield>

                <nx-error *ngIf="(this.currentForm.controls.saveOfferOwnerData.get('phoneNumber')?.value?.errors)"
                class="field-error"
                appearance="text">
                  {{ "error.errorMessage" | translate }}
                </nx-error> -->

            </div>
            <div nxCol="12" align="center" *ngIf="data.offer" class="nx-margin-top-3m" id="buttonSave">
                <qbe-button [mode]="'primary'" [disabled]="!currentForm.controls.saveOfferOwnerData.controls.email.valid
                    ||
                    currentForm.controls.saveOfferOwnerData.controls.email.value
                    == null" (click)="saveOffer(calculatedPermiums)" (click)="this.trackService.pushEventTracking('navigationButton','Save and send')">
                    <span style="padding-left: 32px; padding-right: 32px;"> {{ data.btnOkText | translate}} </span> 
                </qbe-button>
            </div>
            <div nxCol="12" align="center" *ngIf="data.agent &&
                !data.btnCloseText" class="nx-margin-top-3m" id="buttonSave">
                <qbe-button [mode]="'primary'" [disabled]="!currentForm.valid" (click)="sendError()" (click)="this.trackService.pushEventTracking('navigationButton','Call me')">
                   <span  style="padding-left: 32px; padding-right: 32px;"> {{ data.btnOkText | translate}} </span> 
                </qbe-button>
            </div>
            <div nxCol="12" class="under-img" *ngIf="data.image || data.svg">
                <qbe-illustration *ngIf="data.image" [name]="data.image" width="140px" class="thankYou-image">
                </qbe-illustration>
                <img aemNormalizeUrl *ngIf="data.svg" [src]="data.svg" alt="Thank you" />
            </div>
            <!--<div nxCol="12" align="center" *ngIf="data.btnCloseText" class="nx-margin-top-3m">
        <qbe-button [mode]="'primary'" (click)="close()">
          {{ data.btnCloseText | translate}}
        </qbe-button>
      </div>-->
        </div>
    </ng-container>
</form>